// extracted by mini-css-extract-plugin
export const wrapper = "posts-template-module--wrapper--1Y49O";
export const side = "posts-template-module--side--7vWRN";